import React from 'react';
import TouchLink from '../../components/TouchLink';

const LoginNav = React.createClass({
	render(){

		let active = this.props.active || 'login';

		return (
			<nav className="login-nav">
				<TouchLink className={active === 'login' ? "active" : null} to="/login" stateReplace={true}>Log in</TouchLink>
				<TouchLink className={active === 'signup' ? "active" : null} to="/signup" stateReplace={true}>Sign up</TouchLink>
			</nav>
		);
	}
});
export default LoginNav;


/** WEBPACK FOOTER **
 ** ./src/components/LoginNav/LoginNav.js
 **/